// src/components/BadgeShelf.js
import React from 'react';
import { getEarnedBadges } from '../utils/gamification';
import './BadgeShelf.css';

/**
 * Displays a grid of earned / locked badges.
 *
 * compact  true  → small emoji-only pills (for sidebar / bid cards)
 * compact  false → full grid with labels + descriptions
 */
const BadgeShelf = ({ provider, compact = false }) => {
  const badges = getEarnedBadges(provider);
  const earned = badges.filter(b => b.earned);
  const locked = badges.filter(b => !b.earned);

  if (compact) {
    if (earned.length === 0) return null;
    return (
      <div className="badge-shelf-compact">
        {earned.map(b => (
          <span key={b.id} className="bsc-pill" title={`${b.label}: ${b.desc}`}>
            {b.emoji}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div className="badge-shelf">
      <h3 className="bs-heading">BADGES &amp; <span>ACHIEVEMENTS</span></h3>
      <div className="bs-grid">
        {earned.map(b => (
          <div key={b.id} className="bs-badge bs-earned" title={b.desc}>
            <div className="bs-emoji">{b.emoji}</div>
            <div className="bs-label">{b.label}</div>
            <div className="bs-desc">{b.desc}</div>
          </div>
        ))}
        {locked.map(b => (
          <div key={b.id} className="bs-badge bs-locked" title={`Locked: ${b.desc}`}>
            <div className="bs-emoji bs-lock-icon">🔒</div>
            <div className="bs-label">{b.label}</div>
            <div className="bs-desc">{b.desc}</div>
          </div>
        ))}
      </div>
      {earned.length === 0 && (
        <p className="bs-empty">Complete jobs and hit milestones to unlock badges!</p>
      )}
    </div>
  );
};

export default BadgeShelf;
